import { useComposeFormContext } from "shared/components/message/compose/context";
import { useFormState } from "shared/hooks/useFormState";
import { to } from "shared/utils/fns";
import { Cm, MessageSeverity } from "src/gql/graphql";

type CmInput = Cm | Cm[];

const asArray = (input: CmInput) => (Array.isArray(input) ? input : [input]);

export const useComposeFormCmSelection = () => {
    const form = useComposeFormContext();
    const [options, setOptions] = useFormState(form, "options");
    const [severity] = useFormState(form, "severity");

    const selectedCms = options.map(to("method"));
    const isUrgent = severity === MessageSeverity.Urgent;
    const effectiveCms = isUrgent ? Object.values(Cm) : selectedCms;

    const hasAny = (cms: CmInput) => asArray(cms).some((method) => effectiveCms.includes(method));

    return {
        isUrgent,
        selectedCms,
        setOptions,
        hasAny,
        effectiveCms,
    };
};
